        // Step 1 - Informações gerais (CNPJ)
        function generateValidCNPJ() {
            // Gera aleatoriamente os 8 primeiros dígitos
            const rand = () => Math.floor(Math.random() * 9);
            let n = [];
            for (let i = 0; i < 8; i++) n.push(rand());
            // Define a ordem usual dos CNPJs (8 dígitos, 4 dígitos fixos)
            n = n.concat([0, 0, 0, 1]);
            // Calcula os dígitos verificadores
            const calcDv = (arr) => {
                let size = arr.length;
                let weights = [];
                for (let i = size - 7, j = 0; j < size; i++, j++) {
                    weights[j] = i <= 1 ? i + 7 : i;
                }
                let sum = arr.reduce((p, c, idx) => p + c * weights[idx], 0);
                let r = sum % 11;
                return r < 2 ? 0 : 11 - r;
            };
            let dv1 = calcDv(n);
            let dv2 = calcDv([...n, dv1]);
            return `${n.slice(0, 2).join('')}.${n.slice(2, 5).join('')}.${n.slice(5, 8).join('')}/${n.slice(8, 12).join('')}-${dv1}${dv2}`;
        }

        // Função utilitária para gerar valores aleatórios de string/email/etc
        function randomString(length = 8) {
            const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        }

        function randomName() {
            const names = ["Joana", "Lucas", "Maria", "Carlos", "Paula", "Eduardo", "Fernanda", "Roberto", "Juliana", "André"];
            const surnames = ["Barbosa", "Silva", "Souza", "Oliveira", "Lima", "Pereira", "Costa", "Gomes", "Ribeiro", "Martins"];
            return `${names[Math.floor(Math.random() * names.length)]} ${surnames[Math.floor(Math.random() * surnames.length)]}`;
        }

        // Gera um valor randomico para phone
        function randomPhone() {
            return `11${Math.floor(90000 + Math.random() * 10000)}${Math.floor(1000 + Math.random() * 9000)}`;
        }

        // Gera uma data de nascimento aleatória
        function randomBirthdate() {
            const year = Math.floor(Math.random() * 20) + 1980;
            const month = ('0' + (Math.floor(Math.random() * 12) + 1)).slice(-2);
            const day = ('0' + (Math.floor(Math.random() * 28) + 1)).slice(-2);
            return `${day}/${month}/${year}`;
        }

        // Gera um documento CPF válido aleatório
        function generateValidCPF() {
            const n = [];
            for (let i = 0; i < 9; i++) n.push(Math.floor(Math.random() * 9));
            function calcDv(numbers) {
                let sum = 0;
                for (let i = 0; i < numbers.length; i++) {
                    sum += numbers[i] * ((numbers.length + 1) - i);
                }
                let dv = sum % 11;
                return dv < 2 ? 0 : 11 - dv;
            }
            const dv1 = calcDv(n);
            const dv2 = calcDv(n.concat([dv1]));
            return `${n[0]}${n[1]}${n[2]}.${n[3]}${n[4]}${n[5]}.${n[6]}${n[7]}${n[8]}-${dv1}${dv2}`;
        }

export { generateValidCNPJ, randomString, randomName, randomPhone, randomBirthdate, generateValidCPF };